/**
 * Formats product descriptions based on configuration
 */
export class DescriptionFormatter {
  /**
   * Gets formatted description or empty string
   */
  static format(
    hideProductDescription: boolean | undefined,
    description: string | undefined
  ): string {
    return hideProductDescription ? '' : (description ?? '')
  }
}
